interface ShareOptions {
  title?: string;
  text?: string;
  url?: string;
}

export async function share({ title, text, url }: ShareOptions) {
  const shareData = {
    title: title || document.title,
    text: text || "",
    url: url || window.location.href,
  };

  try {
    if (navigator.share) {
      await navigator.share(shareData);
      console.log("Compartilhado com sucesso!");
    } else {
      // Fallback para copiar link
      await navigator.clipboard.writeText(shareData.url);
      alert("Link copiado para a área de transferência!");
    }
  } catch (err) {
    console.error("Erro ao compartilhar:", err);
    alert("Não foi possível compartilhar o link.");
  }
}
